import ky from "ky";

import { config } from "@shared/config";

export const client = ky.create({});

export const clientBase = ky.create({
  // prefixUrl: config.api.baseApiUrl,
  prefixUrl: "http://localhost:3000",
});
